import { Combobox } from '@mantine/core';
import clsx from 'clsx';

import { Checkbox } from '../checkbox/Checkbox';
import { TextWithTooltip } from '../tooltip/TextWithTooltip';

import styles from './select-option.module.scss';

type SelectOptionProps = {
  selected: boolean;
  /* display checkbox */
  checkbox?: boolean;
  value: string;
  variant?: 'primary' | 'secondary';
  label: string;
};

export function SelectOption({
  checkbox = false,
  selected,
  value,
  variant,
  label,
}: SelectOptionProps) {
  return (
    <Combobox.Option
      role="option"
      key={value}
      value={value}
      active={selected}
      className={clsx(
        styles['option'],
        variant === 'primary' && styles['option--primary']
      )}
    >
      {checkbox && <Checkbox checked={selected} />}
      <TextWithTooltip
        tooltipProps={{
          position: 'right',
          usePortal: true,
        }}
        textProps={{ lineClamp: 1 }}
      >
        {label}
      </TextWithTooltip>
    </Combobox.Option>
  );
}
